import type { Event } from '../types-hoist/event';

/**
 * Get a list of possible event messages from a Sentry event.
 */
export function getPossibleEventMessages(event: Event): string[] {
  const possibleMessages: string[] = [];

  if (event.message) {
    possibleMessages.push(event.message);
  }

  try {
    // @ts-expect-error Try catching to save bundle size
    const lastException = event.exception.values[event.exception.values.length - 1];
    if (lastException?.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  } catch (e) {
    // ignore errors here
  }

  return possibleMessages;
}



// WEBPACK FOOTER //
// ../../../src/utils/eventUtils.ts